import { FC, useState } from 'react';
import styled from '@emotion/styled';
import UnderlineLink from '@comp/UnderlineLink/UnderlineLink';
import H4 from '@base/H4/H4';
import useGoalFAQs from '@api/hooks/goal/useGoalFAQs';
import { Spacings } from '@styles/index';
import ContentDrawer from './ContentDrawer';
import FAQModal from './FAQModal';

const Container = styled.section`
  position: relative;
  margin-top: 80px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 47.95em) {
    margin-top: 40px;
  }
`;

const Row = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const StyledH4 = styled(H4)`
  margin-right: ${Spacings.SPACING_1B};
  @media (max-width: 47.95em) {
    font-size: 18px;
  }
`;

const GreenH4 = styled(H4)`
  font-weight: bold;
  font-size: 20px;
  line-height: 150%;
  color: var(--color-i-green);
  @media only screen and (max-width: 70.95em) {
    font-size: 16px;
    line-height: 100%;
  }
  @media (max-width: 47.95em) {
    font-size: 18px;
  }
`;

type FAQSectionProps = {
  goalUID: string;
  goalSlug: string;
};

const FAQSection: FC<FAQSectionProps> = ({ goalUID, goalSlug }) => {
  const { faqs } = useGoalFAQs();
  const [isModalShown, showModal] = useState<boolean>(false);

  const showFAQs = () => {
    showModal(true);
  };

  const closeModal = () => {
    showModal(false);
  };

  const renderModal = () => {
    if (!faqs?.length) return null;
    return (
      <ContentDrawer open={isModalShown} onClose={closeModal}>
        <FAQModal data={faqs} />
      </ContentDrawer>
    );
  };

  return (
    <Container>
      {renderModal()}
      <Row>
        <StyledH4>Have questions? </StyledH4>

        <UnderlineLink
          disabled
          onClick={showFAQs}
          href="/goal/[goalSlug]/[goalUID]/subscribe"
          as={`/goal/${goalSlug}/${goalUID}/subscribe`}
          color="var(--color-i-green)"
        >
          <GreenH4>Read our FAQs</GreenH4>
        </UnderlineLink>
      </Row>
    </Container>
  );
};

export default FAQSection;
